module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-es-36b45300a602383f0b151af2ad1d4966.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-es.svg
// module id = uV3t
// module chunks = 22